module.exports = __webpack_public_path__ + "img/Companyoperationproofaddresshongkong.71921435.jpg";